export interface DeleteAccountFlowLiterals {
    title: string;
    desc: string;
    cancelbutton?: string;
    deletebutton?: string;
    okbutton?: string;
}


export enum DeleteStatus {
    activeBookings = 'ActiveBookings',
    pendingPayment = 'PendingPayment',
    openedIssues = 'OpenedIssuesATC',
    default = ''
}